"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedVideoFiles = exports.supportedImages = exports.getMembershipRuleFamily = exports.SubscriptionPackages = exports.StepTypes = exports.Status = exports.ServiceTypes = exports.ResourceTypes = exports.ResourceTypeId = exports.ProviderTypes = exports.ProviderTokenTypes = exports.ProviderMainCategories = exports.PricingModel = exports.PaymentMethods = exports.PaymentChannels = exports.PaidStatus = exports.MembershipTypes = exports.MembershipRuleTypes = exports.MembershipRulePeriods = exports.MembershipRuleFamilies = exports.MainServiceTypes = exports.Languages = exports.JoinPolicyTypes = exports.GroupTypes = exports.GenderTypes = exports.FileTypes = exports.EntityTypes = exports.EntityStatusText = exports.EntityStatus = exports.CollaboratorPercentTypes = exports.CollaboratorPercentAmountTypes = exports.ApprovalMethodTypes = exports.AgreementTypes = void 0;
var EntityTypes = exports.EntityTypes = {
  "break": 'break',
  "class": 'class',
  course: 'course',
  event: 'event',
  membership: 'membership',
  product: 'product',
  reservation: 'reservation',
  service: 'service',
  serviceOneTime: 'onetime',
  // old naming
  session: 'session',
  subscription: 'subscription',
  subService: 'subservice',
  video: 'video',
  workDay: 'work_day',
  holiday: 'holiday',
  audio: 'audio',
  image: 'image',
  document: 'document',
  workout: 'workout',
  plan: 'plan',
  client: 'client',
  bundle: 'bundle',
  bundleRenewal: 'bundle_renewal' // PAY-RE-3/REQ-11: off-session MIT renewal of a recurring bundle
};
var ProviderTokenTypes = exports.ProviderTokenTypes = {
  google: 'google',
  zoom: 'zoom',
  coda: 'coda'
};
var GroupTypes = exports.GroupTypes = {
  course: 'course',
  event: 'event',
  membership: 'membership',
  service: 'service',
  serviceOneTime: 'onetime',
  video: 'video',
  plan: 'plan',
  client: 'client',
  bundle: 'bundle'
};
var MembershipTypes = exports.MembershipTypes = {
  service: 'service',
  courseOrEvent: 'course/event',
  video: 'video',
  workout: 'workout',
  subscription: 'subscription',
  access: 'access'
};
var MembershipRuleTypes = exports.MembershipRuleTypes = {
  reservationLimit: 'reservationLimit',
  subscriptionLimit: 'subscriptionLimit',
  cancelReservationLimit: 'cancelReservationLimit',
  cancelSubscriptionLimit: 'cancelSubscriptionLimit',
  cancelPeriod: 'cancelPeriod',
  accessLimit: 'accessLimit',
  accessPeriod: 'accessPeriod',
  accessDayOfWeek: 'accessDayOfWeek',
  access247: 'access247'
};
// A membership rule (a.k.a. "Limitation") belongs to one of two families.
// A "Booking" membership (subscription type) may only carry booking-family rules;
// an "Access" membership (access type) may only carry access-family rules.
var MembershipRuleFamilies = exports.MembershipRuleFamilies = {
  booking: 'booking',
  access: 'access'
};
var MEMBERSHIP_RULE_FAMILY = {
  reservationLimit: 'booking',
  subscriptionLimit: 'booking',
  cancelReservationLimit: 'booking',
  cancelSubscriptionLimit: 'booking',
  cancelPeriod: 'booking',
  accessLimit: 'access',
  accessPeriod: 'access',
  accessDayOfWeek: 'access',
  access247: 'access'
};
var getMembershipRuleFamily = exports.getMembershipRuleFamily = function getMembershipRuleFamily(type) {
  return MEMBERSHIP_RULE_FAMILY[type] || MembershipRuleFamilies.booking;
};
var MembershipRulePeriods = exports.MembershipRulePeriods = {
  day: 'day',
  week: 'week',
  month: 'month',
  allPeriod: 'allPeriod',
  noPeriod: 'noPeriod'
};
var MainServiceTypes = exports.MainServiceTypes = {
  service: 'N',
  course: 'Y',
  event: 'E'
};
var ServiceTypes = exports.ServiceTypes = {
  service: 'N',
  course: 'Y',
  event: 'E',
  videos: 'V',
  workout: 'W',
  membership: 'M'
};
var Status = exports.Status = {
  active: true,
  inactive: false,
  upcoming: 'upcoming',
  completed: 'completed'
};
var EntityStatus = exports.EntityStatus = {
  active: 'A',
  pending: 'P',
  canceled: 'C',
  waitingList: 'WL',
  reimbursed: 'R',
  reserved: 'RSD'
};
var EntityStatusText = exports.EntityStatusText = {
  en: {
    A: 'Active',
    P: 'Pending',
    C: 'Canceled',
    WL: 'Waiting List',
    R: 'Reimbursed',
    RSD: 'Reserved'
  },
  it: {
    A: 'Attivo',
    P: 'In attesa',
    C: 'Cancellato',
    WL: "Lista d'attesa",
    R: 'Rimborsato',
    RSD: 'Riservato'
  }
};
var PaidStatus = exports.PaidStatus = {
  yes: true,
  no: false
};
var GenderTypes = exports.GenderTypes = {
  male: 'M',
  female: 'F'
};
var PricingModel = exports.PricingModel = {
  total: 'total',
  session: 'session',
  hour: 'hour',
  custom: 'custom'
};
var FileTypes = exports.FileTypes = {
  document: 'document',
  image: 'image',
  video: 'video',
  audio: 'audio',
  gif: 'gif'
};
var AgreementTypes = exports.AgreementTypes = {
  sharing: 'sharing',
  email: 'email',
  marketing: 'marketing'
};
var ProviderTypes = exports.ProviderTypes = {
  centers: 'C',
  professionals: 'P'
};
var ProviderMainCategories = exports.ProviderMainCategories = {
  C: 1,
  P: 2
};
var SubscriptionPackages = exports.SubscriptionPackages = {
  grow: 1,
  video: 2,
  allInOne: 3
};
var Languages = exports.Languages = {
  italian: 'Italian',
  english: 'English',
  swedish: 'Swedish',
  german: 'German'
};
var ResourceTypes = exports.ResourceTypes = {
  collaborator: 'collaborator',
  director: 'director',
  manager: 'manager',
  owner: 'owner'
};
var ResourceTypeId = exports.ResourceTypeId = {
  human: 1,
  physical: 2
};
var supportedVideoFiles = exports.supportedVideoFiles = ['mp4', 'mp3', 'avi', 'mov', 'qt', 'wmv', 'webm', 'mkv', 'ogv', 'ogg', 'wav', 'm4a', '3gp'];
var supportedImages = exports.supportedImages = ['jpg', 'jpeg', 'png', 'webp', 'svg', 'peg', 'gif'];
var PaymentMethods = exports.PaymentMethods = [{
  label: 'Cash',
  value: 'Cash'
}, {
  label: 'CreditCard',
  value: 'CreditCard'
}, {
  label: 'DebitCard',
  value: 'DebitCard'
}, {
  label: 'Membership',
  value: 'Membership'
}, {
  label: 'Wallet',
  value: 'Wallet'
}, {
  label: 'BankTransfer',
  value: 'BankTransfer'
}];
var PaymentChannels = exports.PaymentChannels = [{
  label: 'YouDeal',
  value: 'YouDeal'
}, {
  label: 'YouFeel',
  value: 'YouFeel'
}, {
  label: 'WL',
  value: 'WL'
}, {
  label: 'Widget',
  value: 'Widget'
}, {
  label: 'POS',
  value: 'POS'
}, {
  label: 'SEPA',
  value: 'SEPA'
}];
var CollaboratorPercentTypes = exports.CollaboratorPercentTypes = {
  none: 'none',
  individual: 'individual',
  global: 'global'
};
var CollaboratorPercentAmountTypes = exports.CollaboratorPercentAmountTypes = {
  fixed: 'fixed',
  percent: 'percent'
};
var JoinPolicyTypes = exports.JoinPolicyTypes = {
  free: 'free_join',
  inviteOnly: 'invite_only',
  requiresApproval: 'requires_approval'
};
var ApprovalMethodTypes = exports.ApprovalMethodTypes = {
  automatic: 'automatic',
  manual: 'manual'
};
var StepTypes = exports.StepTypes = {
  personal: {
    label: 'Personal Information',
    fields: [{
      id: 'firstname',
      label: 'Firstname'
    }, {
      id: 'lastname',
      label: 'Lastname'
    }, {
      id: 'birthday',
      label: 'Birthday'
    }, {
      id: 'phone',
      label: 'Phone'
    }, {
      id: 'gender',
      label: 'Gender'
    }, {
      id: 'country',
      label: 'Country'
    }, {
      id: 'address',
      label: 'Address'
    }]
  },
  billing_information: {
    label: 'Billing Information',
    fields: [{
      id: 'codiceFiscale',
      label: 'Codice Fiscale'
    }, {
      id: 'piva',
      label: 'PIVA'
    }, {
      id: 'sdi',
      label: 'SDI'
    }]
  },
  body_measurements: {
    label: 'Body Measurements',
    fields: [{
      id: 'weight',
      label: 'Weight'
    }, {
      id: 'height',
      label: 'Height'
    }, {
      id: 'leftBiceps',
      label: 'Left Biceps'
    }, {
      id: 'rightBiceps',
      label: 'Right Biceps'
    }, {
      id: 'leftLeg',
      label: 'Left Leg'
    }, {
      id: 'rightLeg',
      label: 'Right Leg'
    }, {
      id: 'waist',
      label: 'Waist'
    }, {
      id: 'leftCalf',
      label: 'Left Calf'
    }, {
      id: 'rightCalf',
      label: 'Right Calf'
    }, {
      id: 'leanMass',
      label: 'Lean Mass'
    }, {
      id: 'boneMass',
      label: 'Bone Mass'
    }, {
      id: 'visceralFat',
      label: 'Visceral Fat'
    }]
  },
  questions: {
    label: 'Questions'
  },
  documents: {
    label: 'Document Request'
  },
  agreement: {
    label: 'Informativa'
  },
  attachments: {
    label: 'Attachments'
  }
};
